export const CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT'
export const CLEAR_SEARCH_TEXT = 'CLEAR_SEARCH_TEXT'

export const handleChangeSearchText = value => {
  return dispatch => {
    dispatch({
      type: CHANGE_SEARCH_TEXT,
      value
    })
  }
}

export const clearSearchText = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_SEARCH_TEXT
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/search.js